import styled from 'styled-components';
import {
    GREY_400, GREY_500, PURPLE_500, WHITE,
} from '../../constants';

export {
    Container,
    Content,
} from '../CalendarDayView/styled';

export const HeaderLabel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.125rem;
`;

export const WeekdayLabel = styled.span<{ $isToday?: boolean }>`
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: ${(props) => (props.$isToday ? PURPLE_500 : GREY_400)};
`;

export const DayNumber = styled.span<{ $isToday?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.375rem;
    color: ${(props) => (props.$isToday ? WHITE : GREY_500)};
    background: ${(props) => (props.$isToday ? PURPLE_500 : 'transparent')};
`;
